import React from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { Button, Card, Col, Form, Input, InputNumber, notification, Popconfirm, Row, Table } from 'antd'

import _ from 'lodash'
import moment from 'moment'
import { hideLoader, showLoader } from '../../../../modules/actions'
import Request from '../../../../request'
import { connect } from 'react-redux'
import commonStyle from '../../../common.less'
import { RightsWrapper } from '../../../../components/_utils/utils'

const FormItem = Form.Item
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
const EditableContext = React.createContext()

const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
)

const EditableFormRow = Form.create()(EditableRow)

class EditableCell extends React.Component {
    getInput = () => {
        if (this.props.inputType === 'number') {
            return <InputNumber />
        }
        return <Input />
    }

    render() {
        const {
            editing,
            dataIndex,
            title,
            inputType,
            record,
            index,
            ...restProps
        } = this.props
        return (
            <EditableContext.Consumer>
                {form => {
                    const { getFieldDecorator } = form
                    return (
                        <td {...restProps}>
                            {editing ? (
                                <FormItem style={{ margin: 0 }}>
                                    {getFieldDecorator(dataIndex, {
                                        rules: [
                                            {
                                                required: true,
                                                message: `Please Input ${title}!`
                                            }
                                        ],
                                        initialValue: record[dataIndex]
                                    })(this.getInput())}
                                </FormItem>
                            ) : (
                                restProps.children
                            )}
                        </td>
                    )
                }}
            </EditableContext.Consumer>
        )
    }
}


@Form.create()
class AddCity extends React.Component {
    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                dispatch(showLoader())
                let x = await Request.addCity(values)
                dispatch(hideLoader())
                if (!x.error) {
                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })

                    this.loadCities(this.props.form.getFieldValue('stateId'))
                    this.props.form.setFieldsValue({ cityName: null })
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }
    loadAllCountries = () => {
        let params = {
            results: 100,
            sortField: 'countryName',
            sortOrder: 'ascend',
            businessId: activeUser && activeUser.businessId ? activeUser.businessId : '',
        }
        Request.getCountries(params)
            .then(resp => {
                if (resp) {
                    resp.data = resp.data.reduce((temp, vv) => {
                        vv.display = vv.countryName
                        vv.id = vv._id
                        temp.push(vv)
                        return temp
                    }, [])
                    let inputTypes = this.state.inputTypes
                    inputTypes[0].fields[0].options = resp.data
                    this.setState({ inputTypes: inputTypes })
                }
            })
            .catch(err => {
            })
    }
    loadStates = id => {
        Request.loadStates(id)
            .then(daa => {
                daa.result = daa.result.reduce((total, val) => {
                    total.push({
                        _id: val._id,
                        id: val._id,
                        display: val.stateName
                    })
                    return total
                }, [])

                let inputTypes = this.state.inputTypes

                inputTypes[0].fields[1].options = daa.result

                this.setState({ inputTypes: inputTypes, arr: [] })
            })
            .catch(err => {
            })
    }
    loadCities = params => {
        let id = this.props.form.getFieldValue('stateId')
        if (id) {
            return new Promise(async resolve => {
                let data = await Request.loadCities(id)

                let aa = {
                    data: data.result,
                    total: data.result
                }
                if (params && params.cityName) {
                    aa.data = _.filter(aa.data, item => {
                        if (item.cityName.match(new RegExp(params.cityName[0], 'ig'))) {
                            return true
                        }
                    })
                }
                this.setState({ arr: aa.total })
                resolve(aa)
            })
        }
    }

    state = {
        loading: false,
        arr: [],
        editingKey: '',
        findName: '',
        hidden: true,
        inputTypes: [
            {
                fields: [
                    {
                        label: 'Select Country ',
                        key: 'countryId',
                        required: true,
                        type: 'select',
                        showSearch: true,
                        options: [],
                        defaultValue: { key: 'Please Select' },
                        onChange: v => {
                            this.props.form.setFieldsValue({
                                countryId: v,
                                stateId: null
                            })

                            this.loadStates(v)
                        }
                    },
                    {
                        label: 'Select State',
                        key: 'stateId',
                        required: true,
                        showSearch: true,
                        type: 'select',
                        options: [],
                        defaultValue: { key: 'Please Select' },
                        onChange: v => {
                            this.props.form.setFieldsValue({
                                stateId: v
                            })
                            this.loadCities()
                        }
                    },
                    {
                        label: 'City Name',
                        key: 'cityName',
                        required: true
                    }
                ]
            }
        ]
    }

    handleDelete = (val) => {
        Request.deleteCity({ cityId: val._id })
            .then(x => {
                if (x.success) {
                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error',
                        description: x.msg
                    })
                }
                this.loadCities({})
            })
            .catch(err => {
                console.log(err)
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }

    // loadCities = () => {
    //   let id = this.props.form.getFieldValue('stateId')
    //   if (id) {
    //     Request.loadCities(id).then((daa) => {

    //       this.setState({ arr: daa.result, total: 50 })
    //     }).catch((err) => {

    //     })
    //   }
    // }

    refreshCityArr = () => {
        this.loadCities(this.props.form.getFieldValue('stateId'))
    }

    isEditing = record => record._id === this.state.editingKey


    componentDidMount() {
    }


    cancel = () => {
        this.setState({ editingKey: '' })
    }

    save(form, record) {
        form.validateFields((error, row) => {
            if (error) {
                return
            }

            Request.updateCity({
                cityName: row.cityName,
                _id: record._id,
                stateId: record.stateId,
                countryId: record.countryId
            })
                .then(x => {
                    if (x.success) {
                        notification.success({
                            message: 'Success',
                            description: x.msg
                        })
                    } else {
                        notification.error({
                            message: 'Error',
                            description: x.msg
                        })
                    }

                    this.refreshCityArr()
                    this.setState({ editingKey: '' })
                })
                .catch(err => {
                    notification.error({
                        message: 'Error',
                        description: 'Some Error'
                    })
                    this.setState({ editingKey: '' })
                })
        })
    }

    edit(key) {
        this.setState({ editingKey: key })
    }

    constructor(props) {
        super(props)
        this.columns = [
            {
                title: 'City Name',
                key: 'cityName',
                dataIndex: 'cityName',
                searchTextName: 'cityName',
                width: '50%',
                editable: true
            },
            {
                title: 'Created by',
                dataIndex: 'createdByUser',
                width: '25%',
                render: (val, record) => {
                    return (
                        <div>
                            <div
                                className={commonStyle.user}>{record.createdByUser ? record.createdByUser.name : ''}</div>
                            <div>
                                <small>{record.createdByUser && moment(record.createdByUser.time).format('DD-MM-YYYY HH:mm')}</small>
                            </div>
                        </div>
                    )
                }
            },
            {
                title: 'Last updated by',
                dataIndex: 'updatedByUser',
                width: '25%',
                render: (val, record) => {
                    return (
                        <div>
                            <div
                                className={commonStyle.user}>{record.updatedByUser ? record.updatedByUser.name : ''}</div>
                            <div>
                                <small>{record.updatedByUser && moment(record.updatedByUser.time).format('DD-MM-YYYY HH:mm')}</small>
                            </div>
                        </div>
                    )
                }
            },
            {
                title: 'Actions',
                dataIndex: 'operation',
                render: (text, record) => {
                    const editable = this.isEditing(record)
                    return (
                        <div>
                            {editable ? (
                                <span>
                                    <EditableContext.Consumer>
                                        {form => (
                                            <a
                                                href="javascript:;"
                                                onClick={() => this.save(form, record)}
                                                style={{ marginRight: 8 }}>
                                                Save
                                            </a>
                                        )}
                                    </EditableContext.Consumer>
                                    <a onClick={() => this.cancel(record._id)}>Cancel</a>
                                </span>
                            ) : (
                                <div>
                                    <RightsWrapper myRight={'City.edit'}>
                                        <a onClick={() => this.edit(record._id)}>Edit</a>
                                    </RightsWrapper>
                                    <RightsWrapper myRight={'City.delete'}>
                                        <span style={{ marginLeft: 10 }}>
                                            <Popconfirm
                                                title="Sure to delete?"
                                                onConfirm={() => this.handleDelete(record)}>
                                                <a href="javascript:;">Delete</a>
                                            </Popconfirm>
                                        </span>
                                    </RightsWrapper>
                                </div>
                            )}
                        </div>
                    )
                }
            }
        ]
        this.loadAllCountries()
    }

    render() {
        let { filteredInfo } = this.state
        filteredInfo = filteredInfo || {}

        const {
            form: { getFieldDecorator, getFieldValue }
        } = this.props
        const components = {
            body: {
                row: EditableFormRow,
                cell: EditableCell
            }
        }


        const columns = this.columns.map(col => {
            if (!col.editable) {
                return col
            }
            return {
                ...col,
                onCell: record => ({
                    record,
                    inputType: col.dataIndex === 'age' ? 'number' : 'text',
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: this.isEditing(record)
                })
            }
        })

        return (
            <PageHeaderWrapper title={'Add New City'}>
                <Card>
                    <Row>
                        <Col span={12}>
                            <Card>
                                <Form onSubmit={this.handleSubmit}>
                                    {this.state.inputTypes.map((itype, key) => {
                                        return (
                                            <div key={key + 1}>
                                                <GetAllFormFields
                                                    inputSchema={this.state.inputTypes[key]}
                                                    getFieldDecorator={getFieldDecorator}
                                                />
                                            </div>
                                        )
                                    })}
                                    <div style={{ textAlign: 'center' }}>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            loading={this.props.loading}>
                                            SAVE
                                        </Button>
                                    </div>
                                </Form>
                            </Card>
                        </Col>
                        <Col span={12}>
                            {this.state.arr && this.state.arr.length ? (
                                <Card>
                                    <h3>Cities: {this.state.arr.length}</h3>

                                    <Table
                                        components={components}
                                        bordered
                                        dataSource={this.state.arr}
                                        columns={columns}
                                        rowClassName="editable-row"
                                        onChange={this.handleChange}
                                    />

                                    {/* <TableComp columns={columns} apiRequest={this.loadCities}/> */}
                                </Card>
                            ) : null}
                        </Col>
                    </Row>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddCity)
